import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { AccountCircleOutlined as UserIcon } from "@mui/icons-material";

// Read-only "signed in as" indicator: icon + username, truncated with an ellipsis (full name in the title).
// iconOnly keeps just the icon for the collapsed sidebar, with the name in the title and aria-label.
const UserIndicator = ({ username, iconOnly = false, sx }) => {
	if (!username) return null;

	return (
		<Box
			role="group"
			aria-label={`Signed in as ${username}`}
			title={username}
			sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0, color: "primary.main", ...sx }}
		>
			<UserIcon aria-hidden="true" fontSize="small" sx={{ flexShrink: 0 }} />
			{!iconOnly && (
				<Typography component="span" variant="body2" fontWeight="bold" noWrap sx={{ minWidth: 0 }}>
					{username}
				</Typography>
			)}
		</Box>
	);
};

UserIndicator.propTypes = {
	username: PropTypes.string,
	iconOnly: PropTypes.bool,
	sx: PropTypes.object,
};

export default UserIndicator;
